// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pyxwcpeivxgkbqjnaicq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB5eHdjcGVpdnhna2Jxam5haWNxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ1NDE0OTQsImV4cCI6MjA2MDExNzQ5NH0.mT7U3uAvJzC8j4WNj2-GultSzbnU0M_Jv-Nrujgqsvc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);